import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.ReportsRequestPage.CustomScheduleTypeSelector', {
    label: 'Custom recurrency. Send',
    weeklyOption: 'Weekly',
    monthlyOption: 'Monthly',
    annuallyOption: 'Yearly',
});
